import { useToast } from '@chakra-ui/react'
import type { AxiosError } from 'axios'

export const useCustomToast = () => {
    const toast = useToast()

    function successToast<T>(title: string): (r: T) => T {
        return (r: T) => {
            toast({
                title,
                status: 'success',
            })

            return r
        }
    }

    function errorToast<T>(title: string): (e: T) => T {
        return (e: T) => {
            toast({
                title,
                status: 'error',
            })

            return e
        }
    }

    function catchNetworkErrorAndNotify(e: AxiosError) {
        if (e.code === 'ERR_NETWORK')
            toast({
                status: 'error',
                title: 'Chyba při komunikaci se serverem',
                description: 'Zkontrolujte Vaše připojení a zkuste to znovu.',
            })
        else if (e.code === 'ECONNABORTED')
            toast({
                status: 'error',
                title: 'Požadavek byl zrušen, protože trval příliš dlouho.',
                description: 'Zkontrolujte Vaše připojení a zkuste to znovu.',
            })
        else
            throw e
    }

    return {
        successToast,
        errorToast,
        catchNetworkErrorAndNotify,
        toast
    }
}